<template>
	<span :style="allStyles" :class="allClasses" ref="container">{{
		displayValue
	}}</span>
</template>

<script>
export default {
	name: 'NumberDisplay',
	props: {
		value: {
			type: Number,
			required: true
		},
		color: {
			type: String
		},
		negativeColor: {
			type: String
		},
		formatter: {
			type: Function,
			default: undefined
		},
		cssClasses: {
			type: [String, Array],
			default: undefined
		},
		/**
		 * { styleName: styleValue, styleName2: styleValue2  }
		 */
		styles: {
			type: Object,
			default: undefined
		},
		negativeClass: {
			type: String,
			default: 'is-negative'
		},
		positiveClass: {
			type: String,
			default: 'is-positive'
		},
		useNegativeClass: {
			type: Boolean,
			default: false
		},
		usePositiveClass: {
			type: Boolean,
			default: false
		},
		zeroDisplay: {
			type: String
		}
	},
	computed: {
		displayValue() {
			let result = this.value;

			if (this.value === 0 && this.zeroDisplay) {
				result = this.zeroDisplay;
			} else if (this.formatter !== undefined) {
				result = this.formatter(this.value);
			}

			return result;
		},
		isNegative() {
			let result = false;

			if (
				this.value !== undefined &&
				this.value !== null &&
				this.value < 0
			) {
				result = true;
			}

			return result;
		},
		allStyles() {
			let styleObj = {};

			if (this.styles && typeof this.styles === 'object') {
				styleObj = this.styles;
			}

			if (this.negativeColor && this.isNegative) {
				styleObj.color = this.negativeColor;
			} else if (this.color && !this.isNegative) {
				styleObj.color = this.color;
			}

			return styleObj;
		},
		allClasses() {
			const classes = [];

			if (this.cssClasses) {
				if (Array.isArray(this.cssClasses)) {
					classes.push(...this.cssClasses);
				} else {
					classes.push(this.cssClasses);
				}
			}

			if (
				!this.negativeColor &&
				this.useNegativeClass &&
				this.negativeClass &&
				this.isNegative
			) {
				classes.push(this.negativeClass);
			} else if (
				!this.color &&
				this.usePositiveClass &&
				this.positiveClass &&
				!this.isNegative
			) {
				classes.push(this.positiveClass);
			}

			return classes;
		}
	}
};
</script>

<style lang="scss" scoped></style>
